(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dani-FAQ"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-faq-seccion]').forEach(function(seccion) {
      var tabs = seccion.querySelectorAll('[data-faq-tab]');
      var paneles = seccion.querySelectorAll('[data-faq-panel]');
      var indicador = seccion.querySelector('[data-faq-indicador]');

      function posicionarIndicador(tab) {
        if (!indicador || !tab) return;
        var rect = tab.getBoundingClientRect();
        var contenedor = tab.parentElement;
        var contRect = contenedor.getBoundingClientRect();
        var paddingStr = getComputedStyle(contenedor).paddingLeft;
        var padding = parseFloat(paddingStr) || 0;
        var left = rect.left - contRect.left - padding;
        indicador.style.width = rect.width + 'px';
        indicador.style.transform = 'translateX(' + left + 'px)';
      }

      if (tabs.length > 0 && indicador) {
        var primera = seccion.querySelector('.faq-tab--activa') || tabs[0];
        requestAnimationFrame(function() {
          posicionarIndicador(primera);
        });

        window.addEventListener('resize', function() {
          var activa = seccion.querySelector('.faq-tab--activa');
          posicionarIndicador(activa);
        });
      }

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var id = this.getAttribute('data-faq-tab');
          tabs.forEach(function(t) {
            t.classList.remove('faq-tab--activa');
            t.setAttribute('aria-selected', 'false');
          });
          this.classList.add('faq-tab--activa');
          this.setAttribute('aria-selected', 'true');
          paneles.forEach(function(panel) {
            if (panel.getAttribute('data-faq-panel') === id) {
              panel.classList.add('faq-panel--activo');
            } else {
              panel.classList.remove('faq-panel--activo');
              panel.querySelectorAll('details[open]').forEach(function(d) { d.removeAttribute('open'); });
            }
          });
          posicionarIndicador(this);
        });
      });

      var detalles = seccion.querySelectorAll('.faq-item');
      detalles.forEach(function(det) {
        det.addEventListener('toggle', function() {
          if (this.open) {
            detalles.forEach(function(otro) {
              if (otro !== det && otro.open) otro.removeAttribute('open');
            });
          }
        });
      });

      var scrollContenedor = seccion.querySelector('[data-faq-tabs]');
      var scrollThumb = seccion.querySelector('[data-faq-scroll-thumb]');
      var scrollIndicador = seccion.querySelector('[data-faq-scroll-indicador]');

      if (scrollContenedor && scrollThumb && scrollIndicador) {
        function actualizarIndicador() {
          var scrollWidth = scrollContenedor.scrollWidth;
          var clientWidth = scrollContenedor.clientWidth;
          if (scrollWidth <= clientWidth + 2) {
            scrollIndicador.style.display = 'none';
            return;
          }
          scrollIndicador.style.display = '';
          var ratio = clientWidth / scrollWidth;
          var thumbAnchoPct = Math.max(8, ratio * 100);
          scrollThumb.style.width = thumbAnchoPct + '%';
          var maxScroll = scrollWidth - clientWidth;
          var scrollActual = scrollContenedor.scrollLeft;
          var progreso = maxScroll > 0 ? scrollActual / maxScroll : 0;
          var maxLeftPct = 100 - thumbAnchoPct;
          var leftPct = progreso * maxLeftPct;
          scrollThumb.style.transform = 'translateX(0)';
          scrollThumb.style.left = leftPct + '%';
        }

        actualizarIndicador();

        scrollContenedor.addEventListener('scroll', function() {
          window.requestAnimationFrame(actualizarIndicador);
        });

        window.addEventListener('resize', function() {
          window.requestAnimationFrame(actualizarIndicador);
        });

        if (window.ResizeObserver) {
          var ro = new ResizeObserver(function() { actualizarIndicador(); });
          ro.observe(scrollContenedor);
        }

        setTimeout(actualizarIndicador, 100);
        setTimeout(actualizarIndicador, 500);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-articulo-blog"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init() {
    var secciones = document.querySelectorAll('.ba-articulo-layout');
    secciones.forEach(function(seccion) {
      if (seccion.dataset.baInicializado === 'true') return;
      seccion.dataset.baInicializado = 'true';

      var contenido = seccion.querySelector('[data-ba-contenido]');
      var tocWrapper = seccion.querySelector('[data-ba-toc]');
      var tocList = seccion.querySelector('[data-ba-toc-list]');

      if (!contenido || !tocWrapper || !tocList) return;

      function slugify(text) {
        return String(text || '')
          .toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');
      }

      var h2s = contenido.querySelectorAll('h2');
      if (h2s.length === 0) {
        tocWrapper.hidden = true;
        return;
      }

      var slugsUsados = {};
      h2s.forEach(function(h2, i) {
        var slugBase = slugify(h2.textContent) || ('seccion-' + (i + 1));
        var slug = slugBase;
        var contador = 2;
        while (slugsUsados[slug]) {
          slug = slugBase + '-' + contador;
          contador++;
        }
        slugsUsados[slug] = true;

        if (!h2.id) h2.id = slug;
        var slugFinal = h2.id;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + slugFinal;
        a.className = 'ba-toc-link';
        a.textContent = h2.textContent;

        a.addEventListener('click', function(e) {
          e.preventDefault();
          var target = document.getElementById(slugFinal);
          if (!target) return;
          var offset = 100;
          var pos = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: pos, behavior: 'smooth' });
          if (history.replaceState) history.replaceState(null, '', '#' + slugFinal);
        });

        li.appendChild(a);
        tocList.appendChild(li);
      });

      tocWrapper.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-feed-instagran"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.feed-ig-seccion').forEach(function(seccion) {
      var enlaces = seccion.querySelectorAll('.feed-ig-media-link');
      enlaces.forEach(function(enlace) {
        var video = enlace.querySelector('[data-feed-ig-video]');
        if (!video) return;

        var playRequest = null;

        function reproducir() {
          try {
            video.currentTime = 0;
            playRequest = video.play();
            if (playRequest && typeof playRequest.catch === 'function') {
              playRequest.catch(function() {});
            }
          } catch (e) {}
        }

        function pausar() {
          try {
            if (playRequest && typeof playRequest.then === 'function') {
              playRequest.then(function() { video.pause(); }).catch(function() {});
            } else {
              video.pause();
            }
          } catch (e) {}
        }

        enlace.addEventListener('mouseenter', reproducir);
        enlace.addEventListener('mouseleave', pausar);
        enlace.addEventListener('focusin', reproducir);
        enlace.addEventListener('focusout', pausar);

        if (window.matchMedia('(hover: none)').matches) {
          var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
                reproducir();
              } else {
                pausar();
              }
            });
          }, { threshold: [0, 0.5, 1] });
          observer.observe(video);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-footer01"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFmdFooter(footer) {
    if (!footer || footer.dataset.fmdInit === 'true') return;
    footer.dataset.fmdInit = 'true';

    var desplegables = footer.querySelectorAll('[data-fmd-desplegable]');
    if (!desplegables.length) return;

    desplegables.forEach(function (det) {
      var summary = det.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function () {
        var estaAbierto = det.hasAttribute('open');
        if (!estaAbierto) {
          desplegables.forEach(function (otro) {
            if (otro !== det && otro.hasAttribute('open')) {
              otro.removeAttribute('open');
            }
          });
        }
      });
    });

    document.addEventListener('click', function (e) {
      desplegables.forEach(function (det) {
        if (det.hasAttribute('open') && !det.contains(e.target)) {
          det.removeAttribute('open');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        desplegables.forEach(function (det) {
          if (det.hasAttribute('open')) det.removeAttribute('open');
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-fmd-footer]').forEach(initFmdFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var footer = e.target.querySelector('[data-fmd-footer]');
    if (footer) initFmdFooter(footer);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarBuscador(wrapper) {
    var formularios = wrapper.querySelectorAll('[data-form-buscador], .encabezado-rafas__form-buscador--movil');
    formularios.forEach(function(form) {
      var input = form.querySelector('[data-input-buscar], .encabezado-rafas__input-buscar');
      if (!input) return;
      function actualizarEstado() {
        if (input.value.length > 0) {
          form.classList.add('tiene-texto');
        } else {
          form.classList.remove('tiene-texto');
        }
      }
      input.addEventListener('input', actualizarEstado);
      input.addEventListener('change', actualizarEstado);
      form.addEventListener('reset', function() {
        setTimeout(actualizarEstado, 0);
      });
      actualizarEstado();
    });
  }

  var CLAVE_HISTORIAL = 'encRafasHistorial';
  var MAX_HISTORIAL = 8;

  function leerHistorial() {
    try {
      var raw = localStorage.getItem(CLAVE_HISTORIAL);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function guardarHistorial(lista) {
    try { localStorage.setItem(CLAVE_HISTORIAL, JSON.stringify(lista)); } catch (e) {}
  }

  function anadirAHistorial(item) {
    var lista = leerHistorial();
    lista = lista.filter(function(x) {
      if (item.tipo === 'producto') return x.url !== item.url;
      return !(x.tipo === 'busqueda' && x.texto === item.texto);
    });
    lista.unshift(item);
    if (lista.length > MAX_HISTORIAL) lista = lista.slice(0, MAX_HISTORIAL);
    guardarHistorial(lista);
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function resaltar(texto, query) {
    if (!query) return escapeHtml(texto);
    var safe = escapeHtml(texto);
    var safeQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    try {
      var re = new RegExp('(' + safeQuery + ')', 'gi');
      return safe.replace(re, '<b>$1</b>');
    } catch (e) { return safe; }
  }

  function inicializarPredictivo(wrapper, config) {
    var bloques = [
      {
        input: wrapper.querySelector('[data-predictivo-input]'),
        panel: wrapper.querySelector('[data-predictivo-panel]'),
        inicial: wrapper.querySelector('[data-predictivo-inicial]'),
        historialWrap: wrapper.querySelector('[data-predictivo-historial-wrap]'),
        historialItems: wrapper.querySelector('[data-predictivo-historial-items]'),
        resultados: wrapper.querySelector('[data-predictivo-resultados]'),
        colIzq: wrapper.querySelector('[data-predictivo-col-izq]'),
        colDer: wrapper.querySelector('[data-predictivo-col-der]'),
        cargando: wrapper.querySelector('[data-predictivo-cargando]'),
        vacio: wrapper.querySelector('[data-predictivo-vacio]'),
        limpiar: wrapper.querySelector('[data-predictivo-limpiar-historial]')
      },
      {
        input: wrapper.querySelector('[data-predictivo-input-movil]'),
        panel: wrapper.querySelector('[data-predictivo-panel-movil]'),
        inicial: wrapper.querySelector('[data-predictivo-inicial-movil]'),
        historialWrap: wrapper.querySelector('[data-predictivo-historial-wrap-movil]'),
        historialItems: wrapper.querySelector('[data-predictivo-historial-items-movil]'),
        resultados: wrapper.querySelector('[data-predictivo-resultados-movil]'),
        colIzq: wrapper.querySelector('[data-predictivo-col-izq-movil]'),
        colDer: wrapper.querySelector('[data-predictivo-col-der-movil]'),
        cargando: wrapper.querySelector('[data-predictivo-cargando-movil]'),
        vacio: wrapper.querySelector('[data-predictivo-vacio-movil]'),
        limpiar: wrapper.querySelector('[data-predictivo-limpiar-historial-movil]')
      }
    ];

    bloques.forEach(function(b) {
      if (!b.input || !b.panel) return;
      configurarBloque(b, config, wrapper);
    });
  }

  function configurarBloque(b, config, wrapper) {
    var timer = null;
    var ultimaQuery = '';

    function mostrarInicial() {
      var historial = leerHistorial();
      if (historial.length > 0 && b.historialWrap && b.historialItems) {
        b.historialItems.innerHTML = '';
        historial.forEach(function(item) {
          if (item.tipo === 'producto') {
            var a = document.createElement('a');
            a.className = 'encabezado-rafas__predictivo-item-historial';
            a.href = item.url;
            a.innerHTML = (item.imagen ? '<img src="' + escapeHtml(item.imagen) + '" alt="">' : '') + '<span>' + escapeHtml(item.titulo) + '</span>';
            b.historialItems.appendChild(a);
          } else {
            var btn = document.createElement('a');
            btn.className = 'encabezado-rafas__predictivo-item-historial';
            btn.href = config.searchUrl + '?q=' + encodeURIComponent(item.texto) + '&type=product';
            btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg><span>' + escapeHtml(item.texto) + '</span>';
            b.historialItems.appendChild(btn);
          }
        });
        b.historialWrap.hidden = false;
      } else if (b.historialWrap) {
        b.historialWrap.hidden = true;
      }
      if (b.inicial) b.inicial.hidden = false;
      if (b.resultados) b.resultados.hidden = true;
      if (b.cargando) b.cargando.hidden = true;
      if (b.vacio) b.vacio.hidden = true;
    }

    function abrirPanel() {
      var q = b.input.value.trim();
      b.panel.hidden = false;
      if (wrapper) wrapper.classList.add('predictivo-abierto');
      elevarSeccion(true);
      if (q.length < 2) {
        mostrarInicial();
      } else {
        buscar(q);
      }
    }

    function cerrarPanel() {
      b.panel.hidden = true;
      if (wrapper) {
        var hayOtroAbierto = wrapper.querySelector('[data-predictivo-panel]:not([hidden]), [data-predictivo-panel-movil]:not([hidden])');
        if (!hayOtroAbierto) {
          wrapper.classList.remove('predictivo-abierto');
          elevarSeccion(false);
        }
      }
    }

    function elevarSeccion(elevar) {
      var seccion = wrapper ? wrapper.closest('.shopify-section') : null;
      if (!seccion) return;
      if (elevar) {
        seccion.style.setProperty('position', 'relative', 'important');
        seccion.style.setProperty('z-index', '2147483647', 'important');
      } else {
        seccion.style.removeProperty('z-index');
        seccion.style.removeProperty('position');
      }
    }

    function buscar(query) {
      if (b.inicial) b.inicial.hidden = true;
      if (b.vacio) b.vacio.hidden = true;
      if (b.resultados) b.resultados.hidden = true;
      if (b.cargando) b.cargando.hidden = false;

      var url = config.suggestUrl + '?q=' + encodeURIComponent(query) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=' + config.limite +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';

      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (b.input.value.trim() !== query) return;
          pintarResultados(data, query);
        })
        .catch(function() {
          if (b.cargando) b.cargando.hidden = true;
          if (b.vacio) b.vacio.hidden = false;
        });
    }

    function pintarResultados(data, query) {
      if (b.cargando) b.cargando.hidden = true;
      var res = (data && data.resources && data.resources.results) ? data.resources.results : {};
      var productos = res.products || [];
      var colecciones = res.collections || [];
      var paginas = res.pages || [];

      if (productos.length === 0 && colecciones.length === 0 && paginas.length === 0) {
        if (b.vacio) b.vacio.hidden = false;
        if (b.resultados) b.resultados.hidden = true;
        return;
      }

      b.colIzq.innerHTML = '';
      b.colDer.innerHTML = '';

      if (colecciones.length > 0) {
        var gC = document.createElement('div');
        gC.innerHTML = '<p class="encabezado-rafas__predictivo-grupo-titulo">' + escapeHtml(config.txtCategorias) + '</p>';
        colecciones.forEach(function(c) {
          var a = document.createElement('a');
          a.className = 'encabezado-rafas__predictivo-fila';
          a.href = c.url;
          var img = c.featured_image && c.featured_image.url ? '<img src="' + escapeHtml(c.featured_image.url) + '" alt="">' : '';
          a.innerHTML = img + '<span class="encabezado-rafas__predictivo-fila-texto"><span class="encabezado-rafas__predictivo-fila-titulo">' + resaltar(c.title, query) + '</span></span>';
          gC.appendChild(a);
        });
        b.colIzq.appendChild(gC);
      }

      if (paginas.length > 0) {
        var gP = document.createElement('div');
        gP.innerHTML = '<p class="encabezado-rafas__predictivo-grupo-titulo">' + escapeHtml(config.txtPaginas) + '</p>';
        paginas.forEach(function(p) {
          var a = document.createElement('a');
          a.className = 'encabezado-rafas__predictivo-fila';
          a.href = p.url;
          a.innerHTML = '<span class="encabezado-rafas__predictivo-fila-texto"><span class="encabezado-rafas__predictivo-fila-titulo">' + resaltar(p.title, query) + '</span></span>';
          gP.appendChild(a);
        });
        b.colIzq.appendChild(gP);
      }

      if (productos.length > 0) {
        var gPr = document.createElement('div');
        gPr.innerHTML = '<p class="encabezado-rafas__predictivo-grupo-titulo">' + escapeHtml(config.txtProductos) + '</p>';
        productos.slice(0, config.limiteIzq).forEach(function(p) {
          var a = document.createElement('a');
          a.className = 'encabezado-rafas__predictivo-fila';
          a.href = p.url;
          var img = p.featured_image && p.featured_image.url ? '<img src="' + escapeHtml(p.featured_image.url) + '" alt="">' : '';
          a.innerHTML = img + '<span class="encabezado-rafas__predictivo-fila-texto"><span class="encabezado-rafas__predictivo-fila-titulo">' + resaltar(p.title, query) + '</span></span>';
          a.addEventListener('click', function() {
            anadirAHistorial({ tipo: 'producto', titulo: p.title, url: p.url, imagen: (p.featured_image && p.featured_image.url) ? p.featured_image.url : '' });
          });
          gPr.appendChild(a);
        });
        var verTodos = document.createElement('a');
        verTodos.className = 'encabezado-rafas__predictivo-ver-todos';
        verTodos.href = config.searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';
        verTodos.textContent = config.txtVerTodos;
        gPr.appendChild(verTodos);
        b.colIzq.appendChild(gPr);
      }

      productos.forEach(function(p) {
        var a = document.createElement('a');
        a.className = 'encabezado-rafas__predictivo-prod';
        a.href = p.url;
        var img = p.featured_image && p.featured_image.url ? '<img src="' + escapeHtml(p.featured_image.url) + '" alt="">' : '<img src="" alt="">';
        var precio = obtenerPrecio(p);
        a.innerHTML = img +
          '<span class="encabezado-rafas__predictivo-prod-info">' +
          '<span class="encabezado-rafas__predictivo-prod-titulo">' + resaltar(p.title, query) + '</span>' +
          (precio ? '<span class="encabezado-rafas__predictivo-prod-precio">' + precio + '</span>' : '') +
          '</span>';
        a.addEventListener('click', function() {
          anadirAHistorial({ tipo: 'producto', titulo: p.title, url: p.url, imagen: (p.featured_image && p.featured_image.url) ? p.featured_image.url : '' });
        });
        b.colDer.appendChild(a);
      });

      if (b.resultados) b.resultados.hidden = false;
    }

    function aDecimal(valor) {
      if (valor == null) return null;
      if (typeof valor === 'string') {
        var tieneDecimal = valor.indexOf('.') !== -1 || valor.indexOf(',') !== -1;
        var limpio = valor.replace(/[^0-9.,-]/g, '').replace(',', '.');
        var n = parseFloat(limpio);
        if (isNaN(n)) return null;
        if (tieneDecimal) return n;
        return n / 100;
      }
      if (typeof valor === 'number') {
        if (Number.isInteger(valor)) return valor / 100;
        return valor;
      }
      return null;
    }

    function obtenerPrecio(p) {
      var min = aDecimal(p.price_min != null ? p.price_min : p.price);
      var max = aDecimal(p.price_max != null ? p.price_max : p.price);
      if (min == null) return '';
      if (max != null && max > min) {
        return formatearNumero(min) + ' - ' + formatearNumero(max);
      }
      return formatearNumero(min);
    }

    function formatearNumero(num) {
      var str = num.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return str + ' ' + config.moneda;
    }

    b.input.addEventListener('input', function() {
      var q = b.input.value.trim();
      if (q === ultimaQuery) return;
      ultimaQuery = q;
      clearTimeout(timer);
      if (wrapper) wrapper.classList.add('predictivo-abierto');
      elevarSeccion(true);
      if (q.length < 2) {
        mostrarInicial();
        b.panel.hidden = false;
        return;
      }
      timer = setTimeout(function() { buscar(q); }, config.debounce);
    });

    b.input.addEventListener('focus', function() {
      abrirPanel();
    });

    var formDeEsteInput = b.input.closest('form');
    if (formDeEsteInput) {
      formDeEsteInput.addEventListener('submit', function() {
        var q = b.input.value.trim();
        if (q.length > 0) {
          anadirAHistorial({ tipo: 'busqueda', texto: q });
        }
      });
    }

    if (b.limpiar) {
      b.limpiar.addEventListener('click', function(e) {
        e.preventDefault();
        guardarHistorial([]);
        mostrarInicial();
      });
    }

    document.addEventListener('click', function(e) {
      if (b.panel.hidden) return;
      var contenedor = b.input.closest('.encabezado-rafas__buscador') || b.input.closest('.encabezado-rafas__buscador-movil');
      if (contenedor && !contenedor.contains(e.target)) {
        cerrarPanel();
      }
    });

    b.input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') cerrarPanel();
    });
  }

  function inicializarEncabezadoRafas(wrapper) {
    var tipoDesktop = wrapper.dataset.stickyDesktop || 'none';
    var tipoMovil = wrapper.dataset.stickyMovil || 'none';

    var inner = wrapper.querySelector('[data-encabezado-inner]');
    var placeholder = wrapper.querySelector('[data-encabezado-placeholder]');
    if (!inner || !placeholder) return;

    var scrollAnterior = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;
    var estadoFijo = false;
    var timeoutOcultar = null;

    function esDesktop() { return window.innerWidth >= 990; }
    function getTipoActivo() { return esDesktop() ? tipoDesktop : tipoMovil; }

    function aplicarClasesModo() {
      wrapper.classList.remove('modo-d-always', 'modo-d-subida', 'modo-m-always', 'modo-m-subida');
      if (tipoDesktop === 'always') wrapper.classList.add('modo-d-always');
      if (tipoDesktop === 'on-scroll-up') wrapper.classList.add('modo-d-subida');
      if (tipoMovil === 'always') wrapper.classList.add('modo-m-always');
      if (tipoMovil === 'on-scroll-up') wrapper.classList.add('modo-m-subida');
    }

    function actualizarAltura() {
      var altura = inner.offsetHeight;
      var tipoActivo = getTipoActivo();
      if (tipoActivo === 'always') {
        placeholder.style.height = altura + 'px';
        placeholder.style.display = 'block';
      } else {
        placeholder.style.height = '0';
        placeholder.style.display = 'none';
      }
      document.documentElement.style.setProperty('--header-height', altura + 'px');
    }

    aplicarClasesModo();
    actualizarAltura();
    setTimeout(actualizarAltura, 100);
    setTimeout(actualizarAltura, 500);

    window.addEventListener('resize', function() { actualizarAltura(); });

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(actualizarAltura);
      ro.observe(inner);
    }

    function activarFijo() {
      if (timeoutOcultar) { clearTimeout(timeoutOcultar); timeoutOcultar = null; }
      if (estadoFijo) return;
      wrapper.classList.add('fijo');
      void wrapper.offsetWidth;
      requestAnimationFrame(function() { wrapper.classList.add('visible'); });
      estadoFijo = true;
    }

    function desactivarFijo() {
      if (!estadoFijo) return;
      wrapper.classList.remove('visible');
      timeoutOcultar = setTimeout(function() {
        wrapper.classList.remove('fijo');
        estadoFijo = false;
        timeoutOcultar = null;
      }, 320);
    }

    function desactivarFijoInmediato() {
      if (!estadoFijo) return;
      if (timeoutOcultar) { clearTimeout(timeoutOcultar); timeoutOcultar = null; }
      wrapper.classList.add('mm-sin-transicion');
      wrapper.classList.remove('visible');
      wrapper.classList.remove('fijo');
      estadoFijo = false;
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          wrapper.classList.remove('mm-sin-transicion');
        });
      });
    }

    function manejarScroll() {
      var tipoActivo = getTipoActivo();
      var scrollActual = window.pageYOffset || document.documentElement.scrollTop || 0;
      var diferencia = scrollActual - scrollAnterior;

      if (tipoActivo === 'none') {
        if (estadoFijo) desactivarFijoInmediato();
        wrapper.classList.remove('tiene-sombra');
        scrollAnterior = scrollActual;
        ticking = false;
        return;
      }

      if (tipoActivo === 'always') {
        if (scrollActual > 5) {
          wrapper.classList.add('tiene-sombra');
        } else {
          wrapper.classList.remove('tiene-sombra');
        }
      } else if (tipoActivo === 'on-scroll-up') {
        var alturaHeader = inner.offsetHeight;
        if (scrollActual <= 5) {
          if (estadoFijo) { desactivarFijoInmediato(); }
          ticking = false;
          scrollAnterior = scrollActual;
          return;
        }
        if (diferencia < -3 && scrollActual > alturaHeader) {
          activarFijo();
        } else if (diferencia > 3) {
          desactivarFijo();
        }
      }

      scrollAnterior = scrollActual;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(manejarScroll);
        ticking = true;
      }
    }, { passive: true });

    manejarScroll();
  }

  function inicializarTodo() {
    var wrappers = document.querySelectorAll('.encabezado-rafas-wrapper');
    wrappers.forEach(function(wrapper) {
      if (wrapper.dataset.rafasInicializado === 'true') return;
      wrapper.dataset.rafasInicializado = 'true';
      inicializarEncabezadoRafas(wrapper);
      inicializarBuscador(wrapper);

      if (wrapper.dataset.predictivoActivar === 'true') {
        inicializarPredictivo(wrapper, {
          suggestUrl: wrapper.dataset.predictivoSuggestUrl,
          searchUrl: wrapper.dataset.predictivoSearchUrl,
          limite: parseInt(wrapper.dataset.predictivoLimite, 10) || 6,
          limiteIzq: parseInt(wrapper.dataset.predictivoLimiteIzq, 10) || 3,
          debounce: parseInt(wrapper.dataset.predictivoDebounce, 10) || 250,
          moneda: wrapper.dataset.predictivoMoneda || '',
          txtCategorias: wrapper.dataset.predictivoTxtCategorias || 'Categorias',
          txtPaginas: wrapper.dataset.predictivoTxtPaginas || 'Paginas',
          txtProductos: wrapper.dataset.predictivoTxtProductos || 'Productos',
          txtVerTodos: wrapper.dataset.predictivoTxtVertodos || 'Ver todos los productos'
        });
      }

      var btn = wrapper.querySelector('[data-toggle-buscador-movil]');
      var panel = wrapper.querySelector('[data-buscador-movil]');
      if (btn && panel) {
        btn.addEventListener('click', function() {
          var oculto = panel.hasAttribute('hidden');
          if (oculto) {
            panel.removeAttribute('hidden');
            var input = panel.querySelector('input[type="search"]');
            if (input) setTimeout(function() { input.focus(); }, 50);
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      var btnMega = wrapper.querySelector('[data-abrir-megamenu]');
      if (btnMega) {
        btnMega.addEventListener('click', function() {
          document.dispatchEvent(new CustomEvent('megamenu:abrir'));
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarTodo);
  } else {
    inicializarTodo();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.encabezado-rafas-wrapper')) {
      inicializarTodo();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-header02"] && !Shopify.designMode) return;
  try {
    
(function() {
  const contenedores = document.querySelectorAll('.barra-anuncios');
  contenedores.forEach(function(contenedor) {
    const slider = contenedor.querySelector('.barra-anuncios__slider');
    if (slider) {
      const mensajes = Array.from(slider.querySelectorAll('.barra-anuncios__mensaje'));
      if (mensajes.length > 1) {
        const tipoTransicion = slider.dataset.transition || 'fade';
        const velocidad = (parseInt(slider.dataset.velocidad) || 4) * 1000;

        slider.classList.add('barra-anuncios--' + tipoTransicion);

        let indiceActual = 0;
        let intervalo = null;

        function mostrarMensaje(indice) {
          const anterior = indiceActual;
          indiceActual = indice;

          mensajes[anterior].classList.add('barra-anuncios__mensaje--saliendo');
          mensajes[anterior].classList.remove('barra-anuncios__mensaje--activo');

          setTimeout(function() {
            mensajes[anterior].classList.remove('barra-anuncios__mensaje--saliendo');
          }, 600);

          mensajes[indiceActual].classList.add('barra-anuncios__mensaje--activo');
        }

        function siguiente() {
          const proximoIndice = (indiceActual + 1) % mensajes.length;
          mostrarMensaje(proximoIndice);
        }

        function iniciar() {
          intervalo = setInterval(siguiente, velocidad);
        }

        function pausar() {
          clearInterval(intervalo);
        }

        slider.addEventListener('mouseenter', pausar);
        slider.addEventListener('mouseleave', iniciar);

        iniciar();
      }
    }

    const idiomas = contenedor.querySelector('[data-idiomas]');
    if (idiomas) {
      const boton = idiomas.querySelector('.barra-anuncios__idioma-actual');
      if (boton) {
        boton.addEventListener('click', function(e) {
          e.preventDefault();
          idiomas.classList.toggle('barra-anuncios__idiomas--abierto');
        });
      }

      document.addEventListener('click', function(e) {
        if (!idiomas.contains(e.target)) {
          idiomas.classList.remove('barra-anuncios__idiomas--abierto');
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          idiomas.classList.remove('barra-anuncios__idiomas--abierto');
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-layout-coleccion"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init() {
    var secciones = document.querySelectorAll('.cl-coleccion-layout');
    secciones.forEach(function(seccion) {
      if (seccion.dataset.clInicializado === 'true') return;
      seccion.dataset.clInicializado = 'true';

      var contenido = seccion.querySelector('[data-cl-contenido]');
      var tocWrapper = seccion.querySelector('[data-cl-toc]');
      var tocList = seccion.querySelector('[data-cl-toc-list]');

      if (!contenido || !tocWrapper || !tocList) return;

      function slugify(text) {
        return String(text || '')
          .toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');
      }

      var h2s = contenido.querySelectorAll('h2');
      if (h2s.length === 0) {
        tocWrapper.hidden = true;
        return;
      }

      var slugsUsados = {};
      h2s.forEach(function(h2, i) {
        var slugBase = slugify(h2.textContent) || ('seccion-' + (i + 1));
        var slug = slugBase;
        var contador = 2;
        while (slugsUsados[slug]) {
          slug = slugBase + '-' + contador;
          contador++;
        }
        slugsUsados[slug] = true;

        if (!h2.id) h2.id = slug;
        var slugFinal = h2.id;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + slugFinal;
        a.className = 'cl-toc-link';
        a.textContent = h2.textContent;

        a.addEventListener('click', function(e) {
          e.preventDefault();
          var target = document.getElementById(slugFinal);
          if (!target) return;
          var offset = 100;
          var pos = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: pos, behavior: 'smooth' });
          if (history.replaceState) history.replaceState(null, '', '#' + slugFinal);
        });

        li.appendChild(a);
        tocList.appendChild(li);
      });

      tocWrapper.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-layout-pagina"] && !Shopify.designMode) return;
  try {
    
(function() {
  var secciones = document.querySelectorAll('.pgl-seccion');
  secciones.forEach(function(seccion) {
    if (seccion.dataset.pglInit === 'true') return;
    seccion.dataset.pglInit = 'true';
    var cards = seccion.querySelectorAll('[data-card-producto]');
    cards.forEach(function(card) {
      var imgPrincipal = card.querySelector('[data-img-principal]');
      var variantes = card.querySelectorAll('[data-variante-img]');
      var contenedorVar = card.querySelector('[data-variantes]');
      if (!imgPrincipal || variantes.length === 0) return;
      var srcOriginal = imgPrincipal.src;
      variantes.forEach(function(v) {
        v.addEventListener('mouseenter', function(e) {
          e.stopPropagation();
          var nuevoSrc = v.dataset.varianteImg;
          if (nuevoSrc) imgPrincipal.src = nuevoSrc;
          variantes.forEach(function(otro) { otro.classList.remove('tgc-variante-activa'); });
          v.classList.add('tgc-variante-activa');
        });
      });
      if (contenedorVar) {
        contenedorVar.addEventListener('mouseleave', function() { imgPrincipal.src = srcOriginal; });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-main-404"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.documentElement.querySelectorAll('meta[name="robots"]').forEach(function(m) {
    m.parentNode.removeChild(m);
  });
  var meta = document.createElement('meta');
  meta.setAttribute('name', 'robots');
  meta.setAttribute('content', 'noindex, follow');
  document.head.appendChild(meta);

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view_404', {
      page_path: window.location.pathname + window.location.search,
      page_referrer: document.referrer
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-pedidos"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init() {
    var secciones = document.querySelectorAll('.pl-pagina-layout');
    secciones.forEach(function(seccion) {
      if (seccion.dataset.plInicializado === 'true') return;
      seccion.dataset.plInicializado = 'true';

      var contenido = seccion.querySelector('[data-pl-contenido]');
      var tocWrapper = seccion.querySelector('[data-pl-toc]');
      var tocList = seccion.querySelector('[data-pl-toc-list]');

      if (!contenido || !tocWrapper || !tocList) return;

      function slugify(text) {
        return String(text || '')
          .toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');
      }

      var h2s = contenido.querySelectorAll('h2');
      if (h2s.length === 0) {
        tocWrapper.hidden = true;
        return;
      }

      var slugsUsados = {};
      h2s.forEach(function(h2, i) {
        var slugBase = slugify(h2.textContent) || ('seccion-' + (i + 1));
        var slug = slugBase;
        var contador = 2;
        while (slugsUsados[slug]) {
          slug = slugBase + '-' + contador;
          contador++;
        }
        slugsUsados[slug] = true;

        if (!h2.id) h2.id = slug;
        var slugFinal = h2.id;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + slugFinal;
        a.className = 'pl-toc-link';
        a.textContent = h2.textContent;

        a.addEventListener('click', function(e) {
          e.preventDefault();
          var target = document.getElementById(slugFinal);
          if (!target) return;
          var offset = 100;
          var pos = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: pos, behavior: 'smooth' });
          if (history.replaceState) history.replaceState(null, '', '#' + slugFinal);
        });

        li.appendChild(a);
        tocList.appendChild(li);
      });

      tocWrapper.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-seccion4"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-ctf]').forEach(function(seccion) {
      var activo = seccion.dataset.tiltActivo === 'true';
      if (!activo) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (window.matchMedia('(hover: none)').matches) return;

      var wrapper = seccion.querySelector('[data-tilt-wrapper]');
      var target = seccion.querySelector('[data-tilt-target]');
      if (!wrapper || !target) return;

      var intensidad = parseFloat(seccion.dataset.tiltIntensidad) || 8;
      var ticking = false;
      var lastX = 0;
      var lastY = 0;

      function actualizar() {
        var rect = wrapper.getBoundingClientRect();
        var x = lastX - rect.left;
        var y = lastY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var rotateX = ((y - centerY) / centerY) * -intensidad;
        var rotateY = ((x - centerX) / centerX) * intensidad;
        target.style.transform = 'perspective(1200px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) scale(1.02)';
        ticking = false;
      }

      wrapper.addEventListener('mousemove', function(e) {
        lastX = e.clientX;
        lastY = e.clientY;
        if (!ticking) {
          window.requestAnimationFrame(actualizar);
          ticking = true;
        }
      });

      wrapper.addEventListener('mouseleave', function() {
        target.style.transform = 'perspective(1200px) rotateX(0deg) rotateY(0deg) scale(1)';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
